module.exports = __webpack_public_path__ + "img/python.4c44d166.svg";